import {
  backToDpdSiteHeader,
  backToGreenSiteHeader,
} from '../../../controlActions';

export const createHeaderControlActions = props => [
  backToDpdSiteHeader(props),
  backToGreenSiteHeader(props),
];
